import type { ButtonHTMLAttributes, ReactNode } from 'react'
import { haptics } from '../lib/telegram.js'
import styles from './Button.module.css'

type Variant = 'primary' | 'secondary' | 'ghost' | 'danger' | 'success'

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant
  children: ReactNode
}

/**
 * Every tap gets a haptic. Inside Telegram that is most of what makes the UI
 * feel responsive, and it costs nothing (CLAUDE.md > Design system).
 */
export function Button({ variant = 'primary', children, onClick, ...rest }: ButtonProps) {
  return (
    <button
      {...rest}
      className={`${styles.button} ${styles[variant]}`}
      onClick={(event) => {
        haptics.tap()
        onClick?.(event)
      }}
    >
      {children}
    </button>
  )
}
